import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Routes, Route} from 'react-router-dom';
import {Theme} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';
import AcknowledgeDocumentRoutes from '~common/components/acknowledge-document-switch';


import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";

import LanguageButton from '~common/components/app-view/preferred-language-button';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {};

class Invite extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

  handleLanguageChange = (lang:string) => {
    window.location.href = `${window.location.pathname}?lang=${lang}`
  }
  render() {

    const {match} = this.props;
    const {classes}: {classes: ClassNameMap} = this.props;
    const {match} = this.props;
    
    // const urlParams = new URLSearchParams(window.location.search);
    const lang =  (new URLSearchParams(window.location.search)).get('lang');
    const dataUrl = lang ? `/api/portal-users/register?lang=${lang}` : "/api/portal-users/register"

    return (
      <div className={classes.container}>
        <AppView hideLoginButton={true} onLanguageChange={this.handleLanguageChange} history={this.props.history}>
          <DefinitionDataProvider>
            <FormBasedContainer
              preferredLanguage={lang}
              containerType={ContainerTypeEditor}
              noDefinitionFoundMessage={(((window as any).App || {browserEnvironment:{}}).browserEnvironment || {}).BROWSER_EXPIRED_REGISTER_LINK_MESSAGE}
              history={this.props.history}
              match={match}
              hideCancelButton={true}
              dataUrl={"/api/portal-users/register"}
              formSelector={{
                formType: 'userRegistration',
                modules: 'users',
                userType: 'Any'
              }}
              errorFormSelector={{
                formType: 'userRegisterTokenExpire',
                modules: 'users',
                userType: 'Any'
              }}
              successMessage="Your account has been created.  You will now be forwarded to the login page."
              // If provided, redirectUrl where the user will be sent upon success
              returnURL="/login"
              submitButtonText="Register"
              customRenderers={{
                "AcknowledgeDocumentSwitch": AcknowledgeDocumentRoutes 
              }}
              >
            </FormBasedContainer>
          </DefinitionDataProvider>
        </AppView>
      </div>
    );
  }
}

export default withStyles(styles)(Invite);
